/********************************************************* {COPYRIGHT-TOP} ***
 * Licensed Materials - Property of IBM
 *
 * (C) Copyright IBM Corporation 2016, 2022
 *
 * All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 ********************************************************** {COPYRIGHT-END} **/

import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { TextInput } from 'carbon-components-react';

export class TestToolUserCredentials extends Component {
  constructor(props) {
    super(props);

    this.state = {
      username: '',
      passwd: ''
    };

    this.handleUsernameChange = this.handleUsernameChange.bind(this);
    this.handlePasswordChange = this.handlePasswordChange.bind(this);
  }

  componentDidMount() {
    this.configure(this.props);
  }

  configure(props) {
    if (props.userCreds) {
      let newState = {};

      newState.username = props.userCreds.username ? props.userCreds.username : '';
      newState.passwd = props.userCreds.passwd ? props.userCreds.passwd : '';

      this.setState(newState);
    }
  }

  handleUsernameChange(event) {
    let newCreds = Object.assign(this.state, { username: event.target.value });
    this.setState(newCreds);
    if (this.props.onChange && typeof this.props.onChange === 'function') {
      this.props.onChange(newCreds);
    }
  }

  handlePasswordChange(event) {
    let newCreds = Object.assign(this.state, { passwd: event.target.value });
    this.setState(newCreds);
    if (this.props.onChange && typeof this.props.onChange === 'function') {
      this.props.onChange(newCreds);
    }
  }

  render() {
    let { t } = this.props;
    let { username, passwd } = this.state;

    return (
      <div className="testToolUserCredentials">
        <div className="username">
          <div className="labelText">{t('username')}</div>
          <TextInput id="username" hideLabel labelText={t('username')} value={username} onChange={this.handleUsernameChange} />
        </div>

        <div className="password">
          <div className="labelText">{t('password')}</div>
          <TextInput.PasswordInput id="password" labelText={t('password')} hideLabel value={passwd} onChange={this.handlePasswordChange} />
        </div>
      </div>
    );
  }
}

export default withTranslation()(TestToolUserCredentials);
